<template>
    <div>
        <!--<sidebar></sidebar>-->
        <div class="app">
            <!--<sidebar></sidebar>-->
            <div class="wrapper" id="app" style="display: flex; flex-direction: row;">
                <menu-drawer></menu-drawer>
                <main class="main" style="padding: 0;">
                    <the-header></the-header>
                    <div class="container">
                        <div>
                            <router-view></router-view>
                        </div>
                    </div>
                    <!--<the-footer></the-footer>-->
                </main>
            </div>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    import Component from 'vue-class-component';
    import TheHeader from '@/components/general/TheHeader';
    import TheFooter from '@/components/general/TheFooter';
    import Sidebar from '@/components/general/Sidebar';
    import MenuDrawer from '@/components/general/menu/Menu';

    @Component
    export default class Home extends Vue {
        name = 'home-page';

        menuVisible = false;

        toggleMenu () {
            this.menuVisible = !this.menuVisible
        }
    }

    Vue.component('home-page', Home);
</script>

<style src="./home.scss" lang="scss" scoped></style>


// WEBPACK FOOTER //
// src/pages/home/Home.vue